function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Emitter } from "./emitter";
var VERSION = "v3";
var ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
export var RegionsManager = /*#__PURE__*/ function() {
    "use strict";
    function RegionsManager(regions) {
        _class_call_check(this, RegionsManager);
        _define_property(this, "collection", []);
        _define_property(this, "alias", void 0);
        if (RegionsManager.instance) {
            return RegionsManager.instance;
        }
        RegionsManager.instance = this;
        if (regions) {
            this.setRegions(regions);
        } else {
            try {
                var storedRegions = localStorage.getItem("vch.regions");
                if (storedRegions) {
                    var _JSON_parse = JSON.parse(storedRegions), data = _JSON_parse.data, timestamp = _JSON_parse.timestamp, version = _JSON_parse.version;
                    if (new Date().getTime() - ONE_WEEK < timestamp && version === VERSION) {
                        this.initRegions(data);
                    }
                }
            } catch (e) {
                console.error("Error while parsing stored regions");
                localStorage.removeItem("vch.regions");
            }
        }
    }
    _create_class(RegionsManager, [
        {
            key: "setRegions",
            value: function setRegions(regions) {
                var collection = regions.filter(function(region) {
                    return typeof region.alias === "string" && typeof region.assets_api_url === "string" && typeof region.deployment_api_url === "string" && typeof region.marketplace_api_url === "string";
                }).map(function(param) {
                    var alias = param.alias, assets_api_url = param.assets_api_url, isDefault = param.default, deployment_api_url = param.deployment_api_url, marketplace_api_url = param.marketplace_api_url, name = param.name;
                    return {
                        alias: alias,
                        deploymentApiUrl: deployment_api_url,
                        filesApiUrl: assets_api_url,
                        isDefault: isDefault,
                        marketApiUrl: marketplace_api_url,
                        name: name
                    };
                });
                this.initRegions(collection);
                localStorage.setItem("vch.regions", JSON.stringify({
                    data: this.collection,
                    timestamp: new Date().getTime(),
                    version: VERSION
                }));
            }
        },
        {
            key: "initRegions",
            value: function initRegions(regions) {
                this.collection = regions;
                var storedRegion = localStorage.getItem("vch.region");
                if (storedRegion && this.collection.find(function(param) {
                    var alias = param.alias;
                    return alias === storedRegion;
                })) {
                    this.alias = storedRegion;
                } else if (this.collection.length > 0) {
                    var _this_collection_find;
                    var _this_collection_find_alias;
                    this.alias = (_this_collection_find_alias = (_this_collection_find = this.collection.find(function(param) {
                        var isDefault = param.isDefault;
                        return isDefault;
                    })) === null || _this_collection_find === void 0 ? void 0 : _this_collection_find.alias) !== null && _this_collection_find_alias !== void 0 ? _this_collection_find_alias : this.collection[0].alias;
                    localStorage.setItem("vch.region", this.alias);
                }
            }
        },
        {
            key: "hasRegions",
            value: function hasRegions() {
                return this.collection.length > 0;
            }
        },
        {
            key: "getRegion",
            value: function getRegion(alias) {
                var _this_collection_find;
                return (_this_collection_find = this.collection.find(function(region) {
                    return region.alias === alias;
                })) !== null && _this_collection_find !== void 0 ? _this_collection_find : this.currentRegion;
            }
        },
        {
            key: "regions",
            get: function get() {
                return this.collection;
            }
        },
        {
            key: "currentRegion",
            get: function get() {
                var _this = this;
                if (!this.alias) {
                    throw new Error("No region selected");
                }
                return this.collection.find(function(param) {
                    var alias = param.alias;
                    return alias === _this.alias;
                });
            }
        },
        {
            key: "currentRegionAlias",
            set: function set(alias) {
                localStorage.setItem("vch.region", alias);
                this.alias = alias;
                Emitter.emit("region:change", this.currentRegion);
            }
        }
    ]);
    return RegionsManager;
}();
_define_property(RegionsManager, "instance", void 0);

//# sourceMappingURL=regions-manager.js.map